import React from "react";
import Footnote from "./Footnote";
import ScriptureRef from "./ScriptureRef";

const tags = {
  para: "p",
  verse: "sup",
  char: "span",
  "verse-span": "span"
};

const getHtmlTagForItem = item => tags[item.name] || "span";

const areVersesInSet = (verseSet = [], verseIds = []) =>
  verseSet.length &&
  verseIds.length &&
  verseSet.find(id => verseIds.indexOf(id) !== -1);

const getAttrsForItem = ({
  highlightedVerseOrgIds,
  index,
  item,
  matchedVerseOrgIds,
  onVerseHover,
  onVerseSelect,
  onVerseUnhover,
  selectedVerseOrgIds
}) => {
  if (item.type === "text") return item.text;
  if (item.name === "verse-span") {
    const { verseOrgIds, verseId } = item.attrs;
    const isSelected = areVersesInSet(selectedVerseOrgIds, verseOrgIds);
    const isHighlighted = areVersesInSet(highlightedVerseOrgIds, verseOrgIds);
    const isMatched = areVersesInSet(matchedVerseOrgIds, verseOrgIds);

    return {
      key: [item.attrs.class, ...verseOrgIds, index].join("-"),
      className: [
        item.attrs.class,
        isSelected ? "selected" : undefined,
        isMatched ? "matched" : undefined,
        isHighlighted ? "highlighted" : undefined
      ].join(" "),
      "data-org-ids": verseOrgIds,
      "data-verse-id": verseId,
      onClick: event => onVerseSelect(verseOrgIds, event),
      onMouseEnter: () => onVerseHover(verseOrgIds),
      onMouseLeave: () => onVerseUnhover(verseOrgIds)
    };
  }

  return {
    key: [item.attrs.style, index].join("-"),
    className: item.attrs.style
  };
};

export default function ScriptureItems(props) {
  const {
    selectedVerseOrgIds,
    children: items,
    highlightedVerseOrgIds,
    matchedVerseOrgIds,
    onVerseSelect,
    onVerseHover,
    onVerseUnhover,
    showRefPreview
  } = props;

  return items.map((item, index) => {
    if (item.type === "text") return item.text;
    if (item.type === "tag") {
      let children;
      const key = [item.name, item.attrs.style, index].join("-");
      switch (item.name) {
        case "note":
          children = (
            <Footnote content={item} key={key}>
              <ScriptureItems {...props}>{item.items}</ScriptureItems>
            </Footnote>
          );
          break;
        case "ref":
          children = (
            <ScriptureRef
              refId={item.attrs.id}
              key={key}
              showRefPreview={showRefPreview}
            >
              <ScriptureItems {...props}>{item.items}</ScriptureItems>
            </ScriptureRef>
          );
          break;
        default:
          children = (
            <ScriptureItems {...props} key={key}>
              {item.items}
            </ScriptureItems>
          );
      }

      return React.createElement(
        getHtmlTagForItem(item),
        getAttrsForItem({
          item,
          index,
          selectedVerseOrgIds,
          highlightedVerseOrgIds,
          matchedVerseOrgIds,
          onVerseSelect,
          onVerseHover,
          onVerseUnhover
        }),
        children
      );
    }
    return null;
  });
}
